// extracted by mini-css-extract-plugin
export default {"close":"OrderChangeHistoryView_close__Asq-z"};